export const version = "rlp/5.4.0";
//# sourceMappingURL=_version.js.map